import I18n from 'I18n';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import { memo } from 'react';
import styled from 'foundations-theming/utils';
import FilterOperatorDateRangeInputMoment from './FilterOperatorDateRangeInputMoment';
import FilterOperatorDateRangeInputMomentAnniversary from './FilterOperatorDateRangeInputMomentAnniversary';
import { GAP, INPUT_WIDTHS, INPUT_WIDTHS_EDITOR_CONDITION, ROW_GAP } from '../../constants/inlineLayout';
import { useElementSize } from '../../hooks/useElementSize';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SinglePanelInputContainer = styled.div.withConfig({
  displayName: "FilterOperatorDateRangeInputMomentOperatorSelect__SinglePanelInputContainer",
  componentId: "sc-1bpznsf-0"
})(["display:flex;flex-wrap:wrap;column-gap:", "px;row-gap:", "px;"], GAP, ROW_GAP);
const SinglePanelOperatorSelectContainer = styled.div.withConfig({
  displayName: "FilterOperatorDateRangeInputMomentOperatorSelect__SinglePanelOperatorSelectContainer",
  componentId: "sc-1bpznsf-1"
})(({
  size
}) => ({
  width: size === 'sm' ? '100%' : `${INPUT_WIDTHS_EDITOR_CONDITION[size]}px`
}));
const SinglePanelInputComponentWrapper = styled.div.withConfig({
  displayName: "FilterOperatorDateRangeInputMomentOperatorSelect__SinglePanelInputComponentWrapper",
  componentId: "sc-1bpznsf-2"
})(({
  size
}) => ({
  minWidth: size === 'sm' ? '100%' : `${INPUT_WIDTHS[size]}px`
}));
const FilterOperatorDateRangeInputMomentOperatorSelect = props => {
  const {
    condition,
    disabled,
    onChange,
    readOnly,
    useOnePanel
  } = props;
  const {
    width
  } = useElementSize();
  const options = [{
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.dateTypeSelection.static'),
    value: false
  }, {
    text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.dateTypeSelection.staticAnniversary'),
    value: true
  }];
  const handleDateTypeChange = evt => {
    onChange(syntheticEvent(condition.set('value', undefined).set('highValue', undefined).set('ignoreYear', evt.target.value.value)));
  };
  const InputComponent = condition.ignoreYear ? FilterOperatorDateRangeInputMomentAnniversary : FilterOperatorDateRangeInputMoment;
  if (useOnePanel) {
    return /*#__PURE__*/_jsxs(SinglePanelInputContainer, {
      children: [/*#__PURE__*/_jsx(SinglePanelOperatorSelectContainer, {
        size: width.size,
        children: /*#__PURE__*/_jsx(UISelect, {
          disabled: disabled,
          onSelectedOptionChange: handleDateTypeChange,
          options: options,
          readOnly: readOnly,
          value: !!condition.ignoreYear
        })
      }), /*#__PURE__*/_jsx(SinglePanelInputComponentWrapper, {
        size: width.size,
        children: /*#__PURE__*/_jsx(InputComponent, Object.assign({}, props, {
          condition: condition,
          onChange: onChange
        }))
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(UISelect, {
        disabled: disabled,
        onSelectedOptionChange: handleDateTypeChange,
        options: options,
        readOnly: readOnly,
        value: !!condition.ignoreYear
      })
    }), /*#__PURE__*/_jsx(InputComponent, Object.assign({}, props, {
      condition: condition,
      onChange: onChange
    }))]
  });
};
export default /*#__PURE__*/memo(FilterOperatorDateRangeInputMomentOperatorSelect);